import type React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Layout from "../../../components/site/Layout/Layout";
import LoginForm from "./components/LoginForm";
import GoogleAuthButton from "../../../components/common/GoogleAuthButton";
import { Separator } from "../../../components/ui/separator";
import { useAuth } from "@/hooks/useAuth";
import { useEffect } from "react";

interface LocationState {
	from: { pathname: string };
}

const LoginPage: React.FC = () => {
	const { isAuthenticated } = useAuth();
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		if (isAuthenticated) {
			const state = location.state as LocationState | null;
			const from = state?.from?.pathname || "/webapp/dashboard";
			navigate(from, { replace: true });
		}
	}, [isAuthenticated, navigate, location]);

	return (
		<Layout>
			<div className="max-w-md mx-auto mt-8">
				<h1 className="text-3xl font-bold mb-6">ログイン</h1>
				<LoginForm />
				<div className="mt-4 text-center">
					<Link
						to="/password-reset"
						className="text-sm text-blue-600 hover:underline"
					>
						パスワードをお忘れの方はこちら
					</Link>
				</div>
				<div className="mt-6 relative">
					<div className="absolute inset-0 flex items-center">
						<Separator className="w-full" />
					</div>
					<div className="relative flex justify-center text-xs uppercase">
						<span className="bg-background px-2 text-muted-foreground">
							または
						</span>
					</div>
				</div>
				<div className="mt-6">
					<GoogleAuthButton mode="login" />
				</div>
				<div className="mt-4 text-center">
					<p>
						アカウントをお持ちでない方は
						<Link to="/signup" className="text-blue-600 hover:underline">
							こちら
						</Link>
						から新規登録してください。
					</p>
				</div>
			</div>
		</Layout>
	);
};

export default LoginPage;
